import('@/assets/style/platforms/dist/sprite.css');
